import { render, staticRenderFns } from "./user-management.vue?vue&type=template&id=5d3c7a94&"
import script from "./user-management.vue?vue&type=script&lang=js&"
export * from "./user-management.vue?vue&type=script&lang=js&"
import style0 from "./user-management.vue?vue&type=style&index=0&id=5d3c7a94&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports